"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBrandDeepLink = exports.getRBIDomain = exports.BrandDeepLinkPrefix = exports.getLinkDomain = exports.LinkDomains = exports.getDomain = void 0;
const brand_1 = require("./brand");
const country_code_1 = require("./country-code");
/**
 * @deprecated Use `getDomain` from `@rbilabs/intl` package instead.
 * WARNING: Do not add more markets in this enum. This is currently only used by
 * older markets that still uses Braze to send transactional emails. Any new market
 * should use the `intl-notification-service` instead to send transactional emails.
 */
var Domains;
(function (Domains) {
    Domains["BK_CH"] = "www.burger-king.ch";
    Domains["BK_DE"] = "www.burgerking.de";
    Domains["BK_GB"] = "www.burgerking.co.uk";
    Domains["BK_NZ"] = "www.burgerking.co.nz";
    Domains["BK_ZA"] = "www.burgerking.co.za";
    Domains["PLK_CH"] = "www.popeyeschicken.ch";
    Domains["PLK_ES"] = "www.popeyeschicken.es";
    Domains["PLK_KR"] = "www.popeyes.co.kr";
    Domains["FHS_CH"] = "www.firehousesubs.ch";
})(Domains || (Domains = {}));
/**
 * Return the production domain for the configured brand
 * @deprecated Use `getDomain` from `@rbilabs/intl` package instead
 */
const getDomain = (brand, locale, platform) => {
    const normalizedLocale = (locale.region || '').toUpperCase();
    switch (brand) {
        case brand_1.Brand.BK:
            switch (normalizedLocale) {
                case country_code_1.IsoCountryCode2Char.CH:
                    return Domains.BK_CH;
                case country_code_1.IsoCountryCode2Char.DE:
                    return Domains.BK_DE;
                case country_code_1.IsoCountryCode2Char.GB:
                    return Domains.BK_GB;
                case country_code_1.IsoCountryCode2Char.NZ:
                    return Domains.BK_NZ;
                case country_code_1.IsoCountryCode2Char.ZA:
                    return Domains.BK_ZA;
                default:
                    return '';
            }
        case brand_1.Brand.PLK:
            switch (locale.region) {
                case country_code_1.IsoCountryCode2Char.CH:
                    return Domains.PLK_CH;
                case country_code_1.IsoCountryCode2Char.ES:
                    return Domains.PLK_ES;
                case country_code_1.IsoCountryCode2Char.KR:
                    return Domains.PLK_KR;
                default:
                    return '';
            }
        case brand_1.Brand.FHS:
            switch (normalizedLocale) {
                case country_code_1.IsoCountryCode2Char.CH:
                    return Domains.FHS_CH;
                default:
                    return '';
            }
        case brand_1.Brand.TH:
        case brand_1.Brand.LTW:
        default:
            return '';
    }
};
exports.getDomain = getDomain;
/**
 * @deprecated Use `getUniversalLinks` from `@rbilabs/intl` package instead.
 * WARNING: Do not add more markets in this enum. This is currently only used by
 * older markets that still uses Braze to send transactional emails. Any new market
 * should use the `intl-notification-service` instead to send transactional emails.
 */
var LinkDomains;
(function (LinkDomains) {
    LinkDomains["BK_CH"] = "burgerkingch.app.link";
    LinkDomains["BK_DE"] = "burgerkingde.app.link";
    LinkDomains["BK_GB"] = "burgerkinguk.app.link";
    LinkDomains["BK_ZA"] = "bksouthafrica.app.link";
})(LinkDomains = exports.LinkDomains || (exports.LinkDomains = {}));
/**
 * Return the production link domain for the configured brand
 * @deprecated Use `getUniversalLinks` from `@rbilabs/intl` package instead.
 */
const getLinkDomain = (brand, locale) => {
    const normalizedLocale = (locale.region || '').toUpperCase();
    switch (brand) {
        case brand_1.Brand.BK:
            switch (normalizedLocale) {
                case country_code_1.IsoCountryCode2Char.CH:
                    return LinkDomains.BK_CH;
                case country_code_1.IsoCountryCode2Char.DE:
                    return LinkDomains.BK_DE;
                case country_code_1.IsoCountryCode2Char.GB:
                    return LinkDomains.BK_GB;
                case country_code_1.IsoCountryCode2Char.ZA:
                    return LinkDomains.BK_ZA;
                default:
                    return '';
            }
        default:
            return '';
    }
};
exports.getLinkDomain = getLinkDomain;
var BrandDeepLinkPrefix;
(function (BrandDeepLinkPrefix) {
    BrandDeepLinkPrefix["BK"] = "burgerking://";
    BrandDeepLinkPrefix["LTW"] = "ltw://";
    BrandDeepLinkPrefix["PLK"] = "popeyes://";
    BrandDeepLinkPrefix["TH"] = "timhortons://";
    BrandDeepLinkPrefix["FHS"] = "firehousesubs://";
})(BrandDeepLinkPrefix = exports.BrandDeepLinkPrefix || (exports.BrandDeepLinkPrefix = {}));
/**
 * Return the rbi development domain for the configured brand and stage.
 * @param brand
 * @param locale
 */
const getRBIDomain = (brand, stage, locale) => {
    const normalizedLocale = (locale.region || '').toLowerCase();
    if (!normalizedLocale) {
        throw new Error(`Unsupported country code ${normalizedLocale}`);
    }
    return `${stage}-${brand.toLowerCase()}-${normalizedLocale}-web.rbi.tools`;
};
exports.getRBIDomain = getRBIDomain;
/**
 * Get the deep link prefix for given brand in given environment.
 *
 * @param {IGetDeepLink} options
 * * brand - the brand whose prefix is needed.
 * * stage - the environment to look up prefix in.
 *
 * @returns {string} The prefix for the brand found in the environment lookup.
 */
const getBrandDeepLink = ({ brand }) => {
    return BrandDeepLinkPrefix[brand];
};
exports.getBrandDeepLink = getBrandDeepLink;
//# sourceMappingURL=domains.js.map